






import Vue from 'vue'
import { AdditionalField } from '@/model/additional-fields/AdditionalField'
import { AdditionalFieldItem } from '@/model/additional-fields/AdditionalFieldItem'

interface ComponentData {
  value: string | null
  decimalRules: Array<Function>
}

export default Vue.extend({
  name: 'AdditionalFieldsDecimalNumber',

  props: {
    item: {
      type: Object as () => AdditionalField
    }
  },

  data (): ComponentData {
    return {
      value: null,
      decimalRules: [
        (value: string) => {
          const pattern = /^$|^(\d+(?:[\.\,]\d{1,20})?)$/
          return pattern.test(value) || this.$t('badValue')
        }
      ],
    }
  },

  watch: {},

  methods: {
    onValueChange (value: string): void {
      const form: any = this.$refs['form']
      if(form.validate()) {
        const payload: AdditionalFieldItem = {
          parentType: this.item.type,
          componentId: this.item.componentId,
          value: value ? value.toString() : '',
          designation: '',
          id: 0,
          groupId: this.item.groupId,
          project: this.item.project
        }
        this.$emit('onValueChange', payload)
      } else {
        this.value = null
        form.resetValidation()
      }
    }
  },

  created () {
    if(this.item) {
      this.value = this.item.value
    }
  }

})
